var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEthereumIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1450_18283)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.96875 0C9.551 0 11.0977 0.469192 12.4133 1.34824C13.7289 2.22729 14.7543 3.47672 15.3598 4.93853C15.9653 6.40034 16.1237 8.00887 15.815 9.56072C15.5064 11.1126 14.7444 12.538 13.6256 13.6569C12.5068 14.7757 11.0813 15.5376 9.52947 15.8463C7.97762 16.155 6.36909 15.9965 4.90728 15.391C3.44547 14.7855 2.19604 13.7602 1.31699 12.4446C0.437942 11.129 -0.03125 9.58225 -0.03125 8C-0.03125 5.87827 0.811605 3.84344 2.3119 2.34315C3.81219 0.842855 5.84702 0 7.96875 0V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.96727 1.71875L10.072 4.86348L12.1767 8.00893L7.96727 10.1297L3.75781 8.00093L5.86254 4.85548L7.96727 1.71875ZM7.96727 10.9769L3.99127 8.85548L7.96727 14.2831L11.9433 8.85548L7.96727 10.9769Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.96875 1.71875L10.0735 4.85548L12.1782 8.00093L7.96875 6.41184V1.71875Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.96875 10.9769L11.9528 8.85547L7.96875 14.2911V10.9769Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.96875 6.41016L12.1782 7.99925L7.96875 10.12V6.41016Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.96727 1.71875L5.86254 4.85548L3.75781 8.00093L7.96727 6.41184V1.71875Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.96819 10.9769L3.99219 8.85547L7.96819 14.2911V10.9769Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.96727 6.41016L3.75781 7.99925L7.96727 10.12V6.41016Z",
    fill: "#353535"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1450_18283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereumIcon);
export default __webpack_public_path__ + "static/media/ethereum-icon.97295639543162d16ab5b60839c2bf67.svg";
export { ForwardRef as ReactComponent };